import { createSlice } from "@reduxjs/toolkit";
import { Booking } from "../../booking-page/store/slice";

export type Schedule = {
  id: number;
  departure_day: number;
  arrival_day: number;
  departure_time: string;
  arrival_time: string;
  duration: string;
  mandatory_reg_country: boolean;
};

export type DisabledPeriod = {
  disabled_from: string;
  disabled_to: string;
};

export type AvailableDays = {
  available_days_of_week: number[];
  disabled_periods: DisabledPeriod[];
};

type InitialState = {
  data: Booking | null;
  isFetching: boolean;
  isLoading: boolean;
  modalMustBeClosed: boolean;

  documentsToAddIds: number[];
  documentsToRemoveIds: number[];

  schedule: Schedule[];
  availableDays: AvailableDays | null;
  isScheduleLoading: boolean;
};

const initialState: InitialState = {
  data: null,
  isFetching: false,
  isLoading: false,
  modalMustBeClosed: false,

  documentsToAddIds: [],
  documentsToRemoveIds: [],

  schedule: [],
  availableDays: null,
  isScheduleLoading: false,
};

const bookingFormSlice = createSlice({
  name: "bookingFormSlice",
  initialState,
  reducers: {
    fetchData: (state, action) => {
      state.isFetching = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    update: (state, action) => {
      state.isLoading = true;
    },
    submit: (state, action) => {
      state.isLoading = true;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsFetching: (state, action) => {
      state.isFetching = action.payload;
    },
    setModalMustBeClosed: (state, action) => {
      state.modalMustBeClosed = action.payload;
    },

    fetchSchedule: (state, action) => {
      state.isScheduleLoading = true;
      state.schedule = [];
    },
    fetchAvailableDays: (state, action) => {
      state.isScheduleLoading = true;
      state.availableDays = null;
    },
    setSchedule: (state, action) => {
      state.schedule = action.payload;
    },
    setAvailableDays: (state, action) => {
      state.availableDays = action.payload;
    },
    setIsScheduleFetching: (state, action) => {
      state.isScheduleLoading = action.payload;
    },

    reset: () => initialState,
  },
});

export default bookingFormSlice;
